import { useI18n } from '../../i18n/i18n';
import type { WorkspaceRole } from '../../workspaces/workspaces-api';

export function RoleBadge({ role }: { role: WorkspaceRole }) {
  const { t } = useI18n();
  return (
    <span className="rounded-sm border border-border bg-tint px-1.5 py-0.5 text-2xs">
      {t(`workspaces.role.${role}`)}
    </span>
  );
}
